export default "__VITE_ASSET__b1OyHZ43__"